import { render, staticRenderFns } from "./GeneralUserConf.vue?vue&type=template&id=b1d2f312&scoped=true&"
import script from "./GeneralUserConf.vue?vue&type=script&lang=js&"
export * from "./GeneralUserConf.vue?vue&type=script&lang=js&"
import style0 from "./GeneralUserConf.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GeneralUserConf.vue?vue&type=style&index=1&id=b1d2f312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d2f312",
  null
  
)

export default component.exports